import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { IntlProvider, FormattedNumber } from 'react-intl';
import { injectConfig, configShape } from '@client/hoc/config';
import { getCurrencyCode } from '@client/helpers';

export class FormatPrice extends PureComponent {
    static propTypes = {
        price: PropTypes.string.isRequired,
        maximumFractionDigits: PropTypes.number,
        superscript: PropTypes.string,
        config: configShape,
    }

    static defaultProps = {
        maximumFractionDigits: 2,
        superscript: ''
    }

    render() {
        const {
            price,
            maximumFractionDigits,
            superscript,
            config,
        } = this.props;

        const currency = getCurrencyCode(parseInt(config.appdomain));
        const style = 'currency';
        const currencyDisplay = 'symbol';
        const overrideCurrencyFormat = config.overrideCurrencyFormat;
        const value = (parseFloat(price) / 100).toFixed(2);

        return (
            <span>
                {overrideCurrencyFormat ?
                    <IntlProvider locale="de">
                        <FormattedNumber
                            style={style}
                            value={value}
                            currencyDisplay={currencyDisplay}
                            maximumFractionDigits={maximumFractionDigits}
                            currency={currency}
                        />
                    </IntlProvider>
                    :
                    <FormattedNumber
                        style={style}
                        value={value}
                        currencyDisplay={currencyDisplay}
                        maximumFractionDigits={maximumFractionDigits}
                        currency={currency}
                    />
                }
                {superscript && (<sup> {superscript}</sup>)}
            </span>
        );

    }
}

export default injectConfig(FormatPrice);
